import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import { MUI_SX_PROP_TYPES } from 'propTypes';

import { HEADER } from 'styles/constants/appearanceSectionNames';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import {
  getHeaderLinkColor,
  getHeaderLinkLightColor,
  getHeaderLinkHoverColor
} from 'styles/helpers/getThemeStyles';

const StyledButton = styled(Button)(({ theme }) => {
  const hoverStyles = {
    color: getHeaderLinkHoverColor(theme)
  };

  return {
    '&.MuiButton-text': {
      opacity: 1,
      '&:hover': hoverStyles
    },
    '& .MuiButton-iconSizeLarge': {
      display: 'flex',
      '& > svg': {
        fill: getHeaderLinkLightColor(theme)
      }
    }
  };
});

const Label = styled(Typography, {
  shouldForwardProp: muiPropForwarding('highlightedLabel', 'ownState')
})(({ theme, highlightedLabel, ownState }) => {
  const activeLabelStyles = highlightedLabel(theme);
  const ownMuiLabelStyles = ownState?.label?.(theme) ?? {};

  const hoverStyles = {
    color: getHeaderLinkHoverColor(theme)
  };

  return {
    padding: '6px 0',
    color: getHeaderLinkColor(theme),
    fontWeight: theme.fonts.medium,
    fontSize: 16,
    ...activeLabelStyles,
    ...ownMuiLabelStyles,
    '&:hover': hoverStyles
  };
});

function IconTextButton({
  'data-testid': dataTestId = null,
  endIcon = null,
  label,
  isActive = false,
  onClick,
  startIcon = null,
  sx = {},
  ownState = {}
}) {
  const highlightedLabel = theme => {
    if (isActive) {
      return {
        borderRadius: 0,
        [theme.breakpoints.up('md')]: {
          borderBottom: `2px ${theme.palette.header.accent.main} solid`
        }
      };
    } else {
      return {};
    }
  };

  const styles = { variant: HEADER };

  return (
    <StyledButton
      data-testid={dataTestId}
      endIcon={endIcon}
      variant="text"
      onClick={onClick}
      size="large"
      startIcon={startIcon}
      sx={sx}
    >
      <Label
        highlightedLabel={highlightedLabel}
        ownState={ownState}
        {...styles}
      >
        {label}
      </Label>
    </StyledButton>
  );
}

IconTextButton.propTypes = {
  'data-testid': PropTypes.string,
  endIcon: PropTypes.node,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  startIcon: PropTypes.node,
  sx: MUI_SX_PROP_TYPES,
  ownState: PropTypes.object
};

export default IconTextButton;
